var render = function render(){var _vm=this,_c=_vm._self._c;return _c('work-item-metadata-provider',{attrs:{"full-path":_vm.rootPageFullPath}},[_c('router-view',{key:_vm.pageKey,staticClass:"work-item-router-view",attrs:{"root-page-full-path":_vm.rootPageFullPath,"with-tabs":_vm.withTabs,"data-testid":"work-item-router-view"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }